import { inject, Injectable } from '@angular/core';
import {
  ServiceInventoryItem,
  ServiceInventoryService,
  ServiceState
} from '@brightside-web/desktop/data-access/service-inventory';
import { toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { BsAuthService, SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';


@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private _serviceInventory = inject(ServiceInventoryService);
  private _modalSvc = inject(SimpleGlobalModalService);

  readonly state = toSignal<ServiceState | null>(
    this._serviceInventory.getService('onboarding').pipe(
      filter((it): it is ServiceInventoryItem => !!it),
      map((it) => it.state),
      distinctUntilChanged()
    ),
    { initialValue: null }
  );

  constructor() {
  }

  loadInventory() {
    this._serviceInventory.loadInventory();
  }

  somethingWentWrong() {
    this._modalSvc.createGenericErrorModal('onboarding', () => {
     this.loadInventory();
    });
  }
}
